import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SupportStudyDis from '../../components/SupportStudyDis/SupportStudyDis';
import * as actions from '../../actions/umk';
import { fetchEducationWorkPrograms,fetchCourse, fetchMetaCourse  } from '../../actions/educationWorkPrograms';
import { educationYear, getYears } from '../../actions/schedule';

import * as curriculumDataActions from '../../actions/curriculumData';

const mapStateToProps = ({ umk, educationWorkPrograms, schedule,  curriculumData }) => ({
  curriculum: umk.curriculum,
  disciplines: umk.disciplines,
  disciplineRPD: educationWorkPrograms.disciplineRPD,
  discipline: educationWorkPrograms.discipline,
  umk: umk.umkList,
  educationPrograms: educationWorkPrograms.educationPrograms,
  educationYears: schedule.educationYear,
  // schoolYears: group.years,
  schoolYears: schedule.studyYear,
  isLoading: educationWorkPrograms.isLoading,

  coursesList: curriculumData.coursesList,
  pagesCount: educationWorkPrograms.pagesCount,
});

const mapDispatchToProps = dispatch => ({
  
  fetchCurriculum: (syid) => dispatch(actions.fetchCirriculum(syid)),
  fetchEdy: () => dispatch(educationYear()),
  // fetchYears: () => dispatch(schoolYear()),
  fetchYears: () => dispatch(getYears()),
  fetchDisciplines: curriculumId => dispatch(actions.fetchDisciplines(curriculumId)),
  fetchUmk: (curriculumId, disciplineId) => dispatch(actions.fetchUmk(curriculumId, disciplineId)),
  fetchEducationPrograms: (numberPage, curriculumId, disciplineId) => dispatch(fetchEducationWorkPrograms(numberPage, curriculumId, disciplineId)),

  getCourses: () => dispatch(curriculumDataActions.getCurriculumCourses()),
  fetchCourse:(params)=> dispatch(fetchCourse(params)),
  fetchMetaCourse:(syid, curriculumId, cid) => dispatch(fetchMetaCourse(syid, curriculumId, cid)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SupportStudyDis)
);
